module.exports = __webpack_public_path__ + "static/media/chief-executive-officer-sign.2d685e13.png";